var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es248.js.map
